<template>
  <div
    v-if="Capacitor.isNativePlatform()"
    class="sticky-top bg-dark"
    style="padding-top: var(--safe-area-inset-top); width: 100%"
  ></div>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core'
</script>
